import { useState, useEffect } from 'react';

import { Company } from '../../../shared/services/api/companies/companies';
import { IBenefitDetails } from '../../interfaces/benefits';

export const useBenefitDetail = (companyId: string, benefitId: string) => {
  const [benefit, setBenefit] = useState<IBenefitDetails | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchBenefitDetail = async () => {
    setLoading(true);
    try {
      const response = await Company.getCompanyBenefitDetail(companyId, benefitId);
      setBenefit(response);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId && benefitId) {
      fetchBenefitDetail();
    }
  }, [companyId, benefitId]);

  return { benefit, loading, error, refetch: fetchBenefitDetail };
};
